import {Suspense} from 'react'
import {createRoot} from 'react-dom/client'
import 'i18n'
import {BrowserRouter as Router} from 'react-router-dom'
import {ThemeProvider, DefaultStyles, LoadingComponent} from '@components/lib'
import queryString from 'query-string'
import {QueryParamProvider} from 'use-query-params'
import {ReactRouter6Adapter} from 'use-query-params/adapters/react-router-6'
import {ConfirmProvider as MuiConfirmProvider} from 'material-ui-confirm'
import {Provider} from 'react-redux'
import {PersistGate} from 'redux-persist/integration/react'

import createStore from 'redux/createStore'
import App from 'containers/App'
import {I18nContextProvider} from 'contexts/I18nContext'
import {ConfirmProvider} from 'contexts/ConfirmContext'
import FontFacesStyle from 'styles/FontFacesStyle'
import * as serviceWorker from 'serviceWorker'
import ReactQueryProvider from 'containers/providers/ReactQueryProvider'
import SnackbarProvider from 'containers/providers/SnackbarProvider'
import SiteView from 'containers/SiteView'

const {store, persistor} = createStore()

const root = createRoot(document.getElementById('root'))

root.render(
  <Suspense fallback={<LoadingComponent isAbsolute />}>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <ThemeProvider>
          <Router>
            <SiteView>
              <ConfirmProvider>
                <MuiConfirmProvider>
                  <DefaultStyles />
                  <FontFacesStyle />
                  <>
                    <I18nContextProvider>
                      <SnackbarProvider>
                        <ReactQueryProvider>
                          <QueryParamProvider
                            adapter={ReactRouter6Adapter}
                            options={{
                              searchStringToObject: queryString.parse,
                              objectToSearchString: queryString.stringify,
                            }}
                          >
                            <App />
                          </QueryParamProvider>
                        </ReactQueryProvider>
                      </SnackbarProvider>
                    </I18nContextProvider>
                  </>
                </MuiConfirmProvider>
              </ConfirmProvider>
            </SiteView>
          </Router>
        </ThemeProvider>
      </PersistGate>
    </Provider>
  </Suspense>,
)

/**
 * If you want your app to work offline and load faster,
 * you can change unregister() to register() below.
 * Note this comes with some pitfalls.
 * @see https://bit.ly/CRA-PWA
 */
serviceWorker.unregister()
